<template>
	<div class="interface">
		<InfoBox v-if="activeInfoBox" @close="toggleInfoBox" />
		<div class="btn-group">
			<button class="pause-btn" @click="toggleInfoBox">Pause</button>
			<MuteToggle eventCategory="Game" />
		</div>
		<component :is="foodbagComopnent" />
		<component :is="timebarComopnent" />
		<!-- <FoodBag ref="foodBag" />
		<TimeBar ref="timeBar" /> -->
		<CycleCountdown v-if="countingDown" />
	</div>
</template>

<script>
import MuteToggle from '@/components/abstract/MuteToggle';
import FoodBag from '@/components/board/FoodBag';
import TimeBar from '@/components/board/TimeBar';
import TutorialFoodBag from '@/components/tutorial/TutorialFoodBag';
import TutorialTimeBar from '@/components/tutorial/TutorialTimeBar';
import CycleCountdown from '@/components/board/CycleCountdown';
import InfoBox from '@/components/board/InfoBox';
import { mapState } from 'vuex';

export default {
	name: 'Interface',
	components: {
		FoodBag,
		TimeBar,
		TutorialFoodBag,
		TutorialTimeBar,
		InfoBox,
		MuteToggle,
		CycleCountdown,
	},
	props: ["foodbagComopnent", "timebarComopnent"],
	data() {
		return {
			activeInfoBox: false,
		};
	},
	computed: {
		...mapState({
			activeCycle: state => state.cycle.active,
			cycleCountdown: state => state.cycle.countingDown,
			muted: state => state.sound.muted,
		}),
		countingDown() {
			return this.cycleCountdown;
		},
	},
	methods: {
		toggleInfoBox() {
			this.activeInfoBox = !this.activeInfoBox;
		},
	},
};
</script>

<style lang="scss" scoped>
	.interface {
		display: flex;
		width: 100%;
		padding: 0 2vw;
		align-items: center;
		justify-content: space-between;
	}

	button {
		display: block;
		height: 20px;
		width: 20px;
		pointer-events: auto;
		background: transparent;
		border: 0;

		@include mobile {
			// height: 35px;
			// width: 35px;
		}
	}

	.pause-btn {
		background-repeat: no-repeat;
		background-position: center center;
		background-image: url('~@assets/img/pause.svg');
		font-size: 0;
	}

	.tutorial-time-bar,
	.time-bar {
		flex-basis: 90%;

		@include mobile {
			position: relative;
			top: -10px;
		}
	}

	.btn-group {
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 1vw 0 0;

		@include mobile {
			position: absolute;
			bottom: 0;
			right: 2vw;
			flex-direction: row;
		}

		> * + * {
			margin-top: 1em;

			@include mobile {
				margin-top: 0;
				margin-left: 1em;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/board/Interface.vue